// Custom.js

// LC: PDP defaults to the 2 bottle variant + 60 day plan for products tagged
// "pdp-default-2-bottles". Collection cards are untouched (they keep showing
// the lowest price / first variant). Skipped when the URL has ?variant=.
// Runs once per product page state (works for direct loads and in-page
// navigation). To remove: delete this block.
(function () {
  var TAG = "pdp-default-2-bottles";
  var applied = new WeakSet();

  function apply() {
    try {
      if (!/\/products\//.test(window.location.pathname)) return;
      var store = window.Alpine && window.Alpine.store && window.Alpine.store("main_product");
      var state = store && store.state;
      var product = state && state.product;
      if (!state || !product || !product.handle) return;
      if (window.location.pathname.indexOf("/products/" + product.handle) === -1) return;
      if (applied.has(state)) return;
      if (!product.tags || Array.prototype.indexOf.call(product.tags, TAG) === -1) {
        applied.add(state);
        return;
      }
      applied.add(state);
      if (new URL(window.location.href).searchParams.get("variant")) return;

      var two = Array.prototype.find.call(product.variants || [], function (v) {
        return v.available && Array.prototype.some.call(v.options || [], function (o) {
          return /^2\s*bottles?$/i.test(String(o).trim());
        });
      });
      if (!two) return;

      if (state.selected_variant && state.selected_variant.id !== two.id) {
        store.setSelectedVariant(two.id, false);
      }
      var plan = Array.prototype.map.call(two.selling_plan_allocations || [], function (a) { return a.selling_plan; })
        .find(function (p) {
          return p && /60\s*days/i.test(p.name || "") && !/birthday/i.test(p.name || "");
        });
      if (plan) store.setSellingPlan(plan.id);
    } catch (e) {}
  }

  setInterval(apply, 250);
})();
